/**
 * 一些公共使用的常量定义
 * */

import { isSandbox } from "~/utils/common";
import { getChannel } from "~/utils/getChannel";

// 邮箱后缀
export const emailSuffixes = [
	"@gmail.com",
	"@yahoo.com",
	"@yahoo.com.sg",
	"@outlook.com",
	"@hotmail.com",
	"@iCloud.com",
	"@singnet.com.sg",
	"@pacific.net.sg",
	"@hongkong.com",
	"@ctimail.com",
	"@hknet.com",
];
// 开发环境添加测试邮箱后缀
if (isSandbox || getChannel() === "hw_return") {
	emailSuffixes.unshift("@qq.com");
	emailSuffixes.unshift("@linghit.com");
}

// 客服链接
export const KEFU_LINK = "https://kf.seerq.io/?scene=11570000&lng=tc";

// 存储相关的 key
export const STORAGE_CHANNEL_KEY = "channel";
export const STORAGE_PLATFORM_KEY = "platform";
export const STORAGE_TOKEN_KEY = "token";
